import React from 'react';

import {Platform, TouchableOpacity, View} from 'react-native';
import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';

import {BodyText} from 'src/Modules/CommonView';

const StickyFooterButton = ({
  handlePress,
  color = global?.color?.orange,
  text = '',
}) => {
  const buttonHeight = 35;
  const {width} = useWindowDimensionsSafe();
  return (
    <TouchableOpacity
      style={{position: 'absolute', bottom: 0, right: 0}}
      onPress={handlePress}
      disabled={!handlePress}
      activeOpacity={0.8}>
      <View
        style={{
          width: width / 2,
          flexDirection: 'row',
        }}>
        <View
          style={{
            alignItems: 'center',
            backgroundColor: color,
            flex: 1,
            height: buttonHeight,
            justifyContent: 'center',
            paddingRight: 10,
            borderTopLeftRadius: Platform.OS == 'android' ? 10 : 0,
          }}>
          <BodyText
            text={text}
            textStyle={{
              color: global?.color?.white,
              fontSize: 14,
              marginBottom: 5,
              textAlign: 'center',
              fontWeight: '700',
            }}
          />
        </View>
      </View>
    </TouchableOpacity>
  );
};

export default StickyFooterButton;
